export const QUOTE_PDF_STYLE_ADJUSTMENTS = {
  cellText: {
    translateY: '-10px',
  },
};

export function adjustQuoteDocumentForPdf(clonedDoc: Document) {
  const offset = QUOTE_PDF_STYLE_ADJUSTMENTS.cellText.translateY;

  clonedDoc.querySelectorAll<HTMLElement>('td, th').forEach(cell => {
    Array.from(cell.childNodes).forEach(node => {
      if (node.nodeType === Node.ELEMENT_NODE) {
        const element = node as HTMLElement;
        element.style.position = 'relative';
        element.style.top = offset;
      } else if (node.nodeType === Node.TEXT_NODE && node.textContent?.trim()) {
        const wrapper = clonedDoc.createElement('span');
        wrapper.style.position = 'relative';
        wrapper.style.top = offset;

        const parent = node.parentNode;
        if (parent) {
          parent.insertBefore(wrapper, node);
          wrapper.appendChild(node);
        }
      }
    });
  });
}
